import { PropertyCategoryModel } from '@_types/molecules';
import Picture from '@atoms/pictures/Picture';
import { getModifiers } from '@helpers/functions';

export default function PropertyCategory(model: PropertyCategoryModel) {
  const { title, image, url } = model;
  const styleModifier = getModifiers(model, 'kf-m-property-category');

  return (
    <a className={styleModifier} href={url}>
      <Picture {...image} />
      <h2 className="h6--sans">{title}</h2>
    </a>
  );
}
